import { useState } from "react";
import { Plus, X } from "lucide-react";
import { BAG_COLORS, bagHex, bagLabel } from "./cargoSlots";

export const BigBagPicker = ({ bags, value, onPick, onAddBag, onRemoveBag }) => {
  const [adding, setAdding] = useState(false);
  return (
    <div data-testid="bigbag-picker" className="space-y-2 max-w-sm">
      <span className="text-xs font-semibold text-zinc-700">Torby big bag</span>
      <div className="flex flex-wrap gap-1.5">
        {bags.map((b) => {
          const code = `bag:${b.id}`;
          const active = value === code;
          return (
            <span key={b.id} className={`inline-flex items-center rounded-full ring-1 transition-[box-shadow,background-color] ${active ? "slot-pop ring-2 ring-orange-500 bg-orange-50" : "ring-zinc-300 bg-white"}`}>
              <button type="button" data-testid={`bigbag-${b.number}`} title={bagLabel(b)} onClick={() => onPick(code)} className="inline-flex items-center gap-1.5 pl-2 pr-1 py-1.5 text-[11px] font-bold uppercase tracking-wider">
                <span className="w-3.5 h-3.5 rounded-full ring-1 ring-black/20" style={{ background: bagHex(b) }} />BB {b.number}
              </button>
              <button type="button" data-testid={`bigbag-remove-${b.number}`} onClick={() => onRemoveBag(b)} aria-label={`Usuń ${bagLabel(b)}`} className="pr-2 pl-0.5 py-1.5 text-zinc-400 hover:text-red-600"><X className="w-3 h-3" /></button>
            </span>
          );
        })}
        <button type="button" data-testid="bigbag-add" onClick={() => setAdding(!adding)} className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full border border-dashed border-zinc-400 text-[11px] font-bold uppercase tracking-wider text-zinc-600 hover:border-orange-500 hover:text-orange-700 transition-colors"><Plus className="w-3 h-3" />Torba</button>
      </div>
      {adding && (
        <div data-testid="bigbag-colors" className="flex flex-wrap gap-2 rounded-xl bg-zinc-50 p-2 ring-1 ring-zinc-200">
          {Object.entries(BAG_COLORS).map(([key, c]) => (
            <button type="button" key={key} data-testid={`bigbag-color-${key}`} title={c.label} aria-label={`Torba ${c.label}`} onClick={() => { onAddBag(key); setAdding(false); }} className="w-8 h-8 rounded-full ring-1 ring-black/20 hover:scale-110 transition-transform" style={{ background: c.hex }} />
          ))}
        </div>
      )}
    </div>
  );
};
